import { FC, useEffect, useRef, useState } from 'react';
import { Button } from 'ncoded-component-library';

import './ExpandableText.styles.scss';
import classNames from 'classnames';

type ExpandableTextProps = {
  text: string;
};

const ExpandableText: FC<ExpandableTextProps> = (props) => {
  const { text } = props;

  const [isExpanded, setIsExpanded] = useState(false);
  const [canOverflow, setCanOverflow] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    const checkOverflow = () => {
      if (textRef.current && !isExpanded) {
        const isOverflowing =
          textRef.current.scrollHeight > textRef.current.clientHeight;
        setCanOverflow(isOverflowing);
      }
    };

    checkOverflow();
    window.addEventListener('resize', checkOverflow);
    return () => {
      window.removeEventListener('resize', checkOverflow);
    };
  }, [isExpanded]);

  return (
    <div className="expandable-text">
      <pre
        className={classNames('expandable-text__text', {
          'expandable-text__text--wrapped': !isExpanded,
        })}
        ref={textRef}
      >
        {text}
      </pre>
      {canOverflow && (
        <>
          {isExpanded && ' '}
          <Button
            type="button"
            variant="link"
            className="expandable-text__btn"
            onClick={() => setIsExpanded((prev) => !prev)}
          >
            {!isExpanded ? 'Show more' : 'Show less'}
          </Button>
        </>
      )}
    </div>
  );
};

export default ExpandableText;
